<template>
  <v-col class="d-flex child-flex gapBetween" cols="4">
    <div class="videoContainerPlay">
      <img
        :src="typeImage.playIcon"
        class="playIcon"
        height="30"
        width="30"
        v-show="source.media.type === 'video'"
      >
      <v-img
        @click="goToPublication(source.key)"
        :src="
          source.media.type === 'video'
            ? (source.media.poster && secureUrl(source.media.poster)) ||
              poster_default
            : source.media.uri && secureUrl(source.media.uri)
        "
        aspect-ratio="1"
        class="grey lighten-2 videoGridItem"
      >
        <template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-progress-circular
              indeterminate
              color="grey lighten-5"
            ></v-progress-circular>
          </v-row>
        </template>
      </v-img>
    </div>
  </v-col>
</template>
<script>
import { RegisterEvent } from '@/analytics'
import { playIcon } from '@/assets/img/index.js'
import { forceSSL } from '@/helper/helper'

export default {
  name: 'gridItems',
  props: {
    source: Object,
    size: Number
  },
  data: () => ({
    poster_default: require('@/assets/img/videoDefault.jpg'),
    typeImage: {
      playIcon: playIcon
    }
  }),
  methods: {
    goToPublication (keyPost) {
      const routeRedirection =
        this.$route.name === 'Favs' ? 'SinglePostFav' : 'SinglePostAuthor'
      RegisterEvent('chi_open_post', {
        target_id: keyPost,
        target_type: 'post_id'
      })
      this.$router.push({
        name: routeRedirection,
        params: {
          postId: keyPost,
          data: this.source
        }
      })
    },
    secureUrl (value) {
      return value && forceSSL(value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mixed/gridItems.vue